import LocalizedStrings from 'localized-strings';

export type LocalizedCategories =
  | 'BANKING'
  | 'CASH'
  | 'CONTRIBUTIONS'
  | 'EQUIPMENT'
  | 'FOOD'
  | 'HOTEL'
  | 'LEGAL'
  | 'LOAN'
  | 'MAINTENANCE'
  | 'MISC'
  | 'PERSONAL'
  | 'RENT'
  | 'SERVICES'
  | 'TAX'
  | 'TELECOM'
  | 'TRANSPORTATION'
  | 'UTILITIES'
  | 'VEHICLE';

const categoriesLocales = new LocalizedStrings({
  en: {
    ALCOOL_TOBACCO: 'Alcohol and tobacco',
    BANKING: 'Bank',
    BETTING: 'Gambling',
    CASH: 'Withdrawal',
    CONTRIBUTIONS: 'Contribution',
    DEFAULT: 'Other expenses',
    EQUIPMENT: 'Equipment',
    FOOD: 'Food',
    HOTEL: 'Hotel',
    LEGAL: 'Legal',
    LOAN: 'Loan',
    MAINTENANCE: 'Maintenance',
    MISC: 'Misc',
    PERSONAL: 'Personal',
    RENT: 'Rent',
    SERVICES: 'Services',
    TAX: 'Tax',
    TELECOM: 'Telecom',
    TRANSPORTATION: 'Transportation',
    UTILITIES: 'Utilities',
    VEHICLE: 'Vehicle',
  },
  fr: {
    ALCOOL_TOBACCO: 'Alcool et tabac',
    BANKING: 'Banque',
    BETTING: "Jeux d'argent",
    CASH: 'Retrait',
    CONTRIBUTIONS: 'Don',
    DEFAULT: 'Autres dépenses',
    EQUIPMENT: 'Équipement',
    FOOD: 'Alimentaire',
    HOTEL: 'Hôtel',
    LEGAL: 'Légal',
    LOAN: 'Emprunt',
    MAINTENANCE: 'Entretien',
    MISC: 'Divers',
    PERSONAL: 'Personnel',
    RENT: 'Loyer',
    SERVICES: 'Services',
    TAX: 'Taxes',
    TELECOM: 'Télécommunication',
    TRANSPORTATION: 'Transport',
    UTILITIES: 'Utilitaires',
    VEHICLE: 'Véhicule',
  },
} as const);

export default categoriesLocales;
